<script setup>
/* import { computed } from "vue"; */
import Credentials from "./Credentials.vue";

/* const showCredentials = computed(() => {
  return route.name === 'Credentials';
}); */

console.log("DASHBOARD PROFILE");
</script>
<template>
  <div class="ml-4" style="width: 100%">
    <div class="px-4" style="width: 100%">
      <!-- <h2 class="dashboard-title" v-show="!showCredentials">Perfil</h2> -->
      <Credentials></Credentials>
    </div>
  </div>
</template>
<style scoped></style>
